module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Order Info","pleaseEntertaxId":"Please enter tax ID (8 digits)"},"zh-tw":{"title":"訂單資訊","pleaseEntertaxId":"請輸入統一編號 (8碼)"}}')
  delete Component.options._Ctor
}
